import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown, FaBars, FaTimes } from 'react-icons/fa';

import logo from "./assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState('');
  const location = useLocation();

  useEffect(() => {
    setCurrentPage(location.pathname);
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(prev => !prev);
  };

  const handleDropdown = (dropdown) => {
    setActiveDropdown(prev => (prev === dropdown ? null : dropdown));
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    setActiveDropdown(null);
  };

  const isCurrentPage = (path) => {
    return currentPage === path;
  };

  const isAssistSection =
    currentPage.includes('/complaints') ||
    currentPage.includes('/pay-slip') ||
    currentPage.includes('/testimonials') ||
    currentPage.includes('/report-review-checklist') ||
    currentPage.includes('/employees') ||
    currentPage.includes('/inspectors-list');

  const isReportsSection =
    currentPage.includes('/udayam-registration-certificate') ||
    currentPage.includes('/registration-certificate') ||
    currentPage.includes('/lrqa-flash-report') ||
    currentPage.includes('/lrqa-inspection-release-note') ||
    currentPage.includes('/lrqa-inspection-report');

  return (
    <nav className="navbar">
      <div className="nav-container">

        <div className="nav-logo">
          <img src={logo} alt="Logo" className="nav-logo-img" />
        </div>

        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>

          <div className="nav-item">
            <Link
              to="/"
              className={`nav-link ${isCurrentPage('/') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              Home
              {isCurrentPage('/') && <span className="page-indicator"></span>}
            </Link>
          </div>

          <div className="nav-item">
            <Link
              to="/about"
              className={`nav-link ${isCurrentPage('/about') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              About
              {isCurrentPage('/about') && <span className="page-indicator"></span>}
            </Link>
          </div>

          <div className="nav-item">
            <Link
              to="/services"
              className={`nav-link ${isCurrentPage('/services') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              Services
              {isCurrentPage('/services') && <span className="page-indicator"></span>}
            </Link>
          </div>

          <div className="nav-item">
            <Link
              to="/blogs"
              className={`nav-link ${isCurrentPage('/blogs') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              Blogs
              {isCurrentPage('/blogs') && <span className="page-indicator"></span>}
            </Link>
          </div>

          {/* ==== ASSIST SECTION ==== */}
          <div className={`nav-item dropdown ${activeDropdown === 'assist' ? 'open' : ''}`}>
            <button
              className={`nav-link dropdown-btn ${isAssistSection ? 'current-page' : ''}`}
              onClick={() => handleDropdown('assist')}
            >
              Assist to enhance <FaChevronDown className="dropdown-icon" />
              {isAssistSection && <span className="page-indicator"></span>}
            </button>

            <div className={`dropdown-menu ${activeDropdown === 'assist' ? 'active' : ''}`}>

              <div className="dropdown-section">
                <div className="dropdown-section-title">Document Services</div>

                <Link to="/complaints" className="dropdown-link" onClick={handleLinkClick}>
                  Complaints
                </Link>

                <Link to="/pay-slip" className="dropdown-link" onClick={handleLinkClick}>
                  Pay Slip
                </Link>

                <Link to="/report-review-checklist" className="dropdown-link" onClick={handleLinkClick}>
                  Report Review Checklist
                </Link>

                <Link to="/employees" className="dropdown-link" onClick={handleLinkClick}>
                  Employees
                </Link>

                <Link to="/inspectors-list" className="dropdown-link" onClick={handleLinkClick}>
                  Inspectors List
                </Link>
              </div>

              <div className="dropdown-divider" />

              <div className="dropdown-section">
                <div className="dropdown-section-title">Client Feedback</div>
                <Link to="/testimonials" className="dropdown-link" onClick={handleLinkClick}>
                  Testimonials
                </Link>
              </div>

            </div>
          </div>

          {/* ==== REPORTS SECTION ==== */}
          <div className={`nav-item dropdown ${activeDropdown === 'reports' ? 'open' : ''}`}>
            <button
              className={`nav-link dropdown-btn ${isReportsSection ? 'current-page' : ''}`}
              onClick={() => handleDropdown('reports')}
            >
              Reports <FaChevronDown className="dropdown-icon" />
              {isReportsSection && <span className="page-indicator"></span>}
            </button>

            <div className={`dropdown-menu ${activeDropdown === 'reports' ? 'active' : ''}`}>

              <Link to="/udayam-registration-certificate" className="dropdown-link" onClick={handleLinkClick}>
                Udayam Registration Certificate
              </Link>

              <Link to="/registration-certificate" className="dropdown-link" onClick={handleLinkClick}>
                Registration Certificate
              </Link>

              <Link to="/lrqa-flash-report" className="dropdown-link" onClick={handleLinkClick}>
                LRQA Flash Report
              </Link>

              <Link to="/lrqa-inspection-release-note" className="dropdown-link" onClick={handleLinkClick}>
                LRQA Inspection Release Note
              </Link>

              <Link to="/lrqa-inspection-report" className="dropdown-link" onClick={handleLinkClick}>
                LRQA Inspection Report
              </Link>

            </div>
          </div>

          <div className="nav-item">
            <Link
              to="/careers"
              className={`nav-link ${isCurrentPage('/careers') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              Careers
              {isCurrentPage('/careers') && <span className="page-indicator"></span>}
            </Link>
          </div>

          <div className="nav-item">
            <Link
              to="/contact"
              className={`nav-link ${isCurrentPage('/contact') ? 'current-page' : ''}`}
              onClick={handleLinkClick}
            >
              Contact Us
              {isCurrentPage('/contact') && <span className="page-indicator"></span>}
            </Link>
          </div>

        </div>

        <div className="nav-toggle" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

      </div>
    </nav>
  );
};

export default Navbar;
